import(/* webpackMode: "eager" */ "/Users/lorion/Documents/code/clipglobe/web/app/[locale]/blog/blog.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
